import { create } from 'zustand';

type ProdutosOrcamento = {
  produtos: any[];
  setProdutos: (produtos: any[]) => void;
};

export const useProdutosOrcamentoStore = create<ProdutosOrcamento>(
  (set, get) => ({
    produtos: [],
    setProdutos: data => set(() => ({ produtos: data })),
    action: () => {
      const produtos = get().produtos;
    },
  }),
);
